let developer = 'prod' // prod.zkqsxt.com
// let developer = "dev" // /dev.zkqsxt.com  
// let developer = "test" // test.zkqsxt.com

module.exports = { developer };
